import { lazy, useEffect } from 'react';
import Cookies from 'js-cookie';
import PropTypes from 'prop-types';
import { useNavigate, useLocation } from 'react-router-dom';

const Password = lazy(() => import('../components/Form/Password'));
const ForgotPassword = lazy(() => import('../components/Form/ForgotPassword'));
const EmailSent = lazy(() => import('../components/Form/EmailSent'));
const ResetPassword = lazy(() => import('../components/Form/ResetPassword'));
const PrivacyPolicy = lazy(() => import('../screens/Main/PrivacyPolicy/PrivacyPolicy'));

const Auth = lazy(() => import('../screens/Auth'));
// const Login = lazy(() => import('../screens/Auth/Login'));
const SignUp = lazy(() => import('../screens/Auth/SignUp'));
const UnauthorizedAccess = lazy(() => import('../screens/UnauthorizedAccess'));
const AccountRegistration = lazy(() => import('../screens/Main/AccountRegistration'));
const AccountRegistrationLinkExpired = lazy(
  () => import('../screens/Main/AccountRegistration/AccountRegistrationLinkExpired'),
);

const PublicRoute = ({ as: Component, ...props }) => {
  const navigate = useNavigate();
  const location = useLocation();
  const isSocialVerified = Cookies.get('socialverified');
  const isVerified = Cookies.get('verified');

  useEffect(() => {
    if (
      (isVerified || isSocialVerified) &&
      !location.pathname.startsWith('/account-setup') &&
      !location.pathname.startsWith('/signup') &&
      !location.pathname.startsWith('/password')
    ) {
      navigate('/homepage');
    }
  }, [isVerified, isSocialVerified, navigate, location.pathname]);

  // return <Component {...props} />;
  // if (Component === AccountRegistration) {
  //   // console.log('SESSION:', isVerified);
  //   return <Component isSession={isVerified} {...props} />;
  // }

  return <Component {...props} />;
};
PublicRoute.propTypes = {
  as: PropTypes.elementType.isRequired,
  // Include other props here if needed
};
const authNav = [
  {
    path: '/',
    element: <SignUp />,
  },
  {
    path: '/signup/:emailparam',
    element: <SignUp />,
  },
  {
    path: '/password',
    element: <Password />,
  },
  {
    path: '/forgot-password',
    element: <ForgotPassword />,
  },
  {
    path: '/unauthorized-access',
    element: <UnauthorizedAccess />,
  },
  {
    path: '/account-setup/:userId',
    element: <PublicRoute as={AccountRegistration} />,
  },
  {
    path: '/account-setup-link-expired',
    element: <AccountRegistrationLinkExpired />,
  },
];

const publicRoutes = [
  {
    path: '/',
    element: <PublicRoute as={Auth} />,
    children: authNav,
  },
  {
    path: 'signup',
    element: <SignUp />,
  },
  {
    path: '/signup/:emailparam',
    element: <SignUp />,
  },
  {
    path: '/password',
    element: <Password />,
  },
  {
    path: '/email-sent',
    element: <EmailSent />,
  },
  {
    path: '/:id/reset-password/:token',
    element: <ResetPassword />,
  },
  {
    path: '/privacy-policy',
    element: <PrivacyPolicy />,
  },
];

export default publicRoutes;
